import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import ButtonGroup2 from '../../../../components/ButtonGroup';
import Authors from '../../../../components/FormComponent/Authors';
import Categorization from '../../../../components/FormComponent/Categorization';
import Content from '../../../../components/FormComponent/Content';
import FilesComplementary from '../../../../components/FormComponent/FilesComplementary';
import MainFile from '../../../../components/FormComponent/MainFile';
import MetaTag from '../../../../components/FormComponent/MetaTag';
// Helpers
import toast from '../../../../helpers/toast';
import { useContentSubmit } from '../../../../hooks';
import { createContent, updateContent } from '../../../../services/contents';
import { getKitsTematic } from '../../../../services/kitsTematics';
import * as styles from './styles';

const CreateAndEditEbooks: React.FC<any> = ({ type }: any) => {
  const [searchParams] = useSearchParams();
  const [isEditing, setIsEditing] = React.useState(true);
  const [isLoading, setIsloading] = React.useState(true);
  const [kitsTematic, setKitsTematic] = React.useState<any>();
  const [isShowing, setIsShowing] = React.useState(false);
  const navigate = useNavigate();
  const onError = () => {
    Swal.fire({
      title: 'Por favor, preencha o formulário corretamente.',
    });
  };

  const getContent = async () => {
    setIsloading(true);
    await getKitsTematic(searchParams.get('id')).then(result => {
      setKitsTematic(result);
      setValue('image_file', result.image_file);
      setValue('image_file_id', result.image_file_id);
    });
    setIsloading(false);
  };

  React.useEffect(() => {
    if (searchParams.get('id') != null) {
      getContent();
      if (searchParams.get('view') != null) {
        setIsShowing(true);
      }
      setIsEditing(true);
    } else {
      setIsEditing(false);
      setIsloading(false);
    }
  }, []);

  const methods = useForm();
  const { handleSubmit, control, setValue, clearErrors, setError, getValues } =
    methods;

  function onSubmit(data: any, status: any) {
    data = { ...data, type: 'thematic_kit', status: status };
    const id: string | null = searchParams.get('id');
    const formProps = { data };

    if (id !== null) formProps['id'] = id;

    const { obj } = useContentSubmit(formProps);

    if (!isEditing) {
      createContent(obj)
        .then(() => {
          Swal.fire({
            title: 'Kit temático criado com sucesso',
            icon: 'success',
          });
          navigate(-1);
        })
        .catch(error => {
          if (error.response.data.errors) {
            Swal.fire({
              title: error.response.data.message,
              icon: 'error',
            });
            error.response.data.errors.map(el =>
              toast({
                message: el.message,
                type: 'warning',
              }),
            );
          } else {
            Swal.fire({
              title: 'Algo deu errado',
              icon: 'error',
            });
          }
        });
    } else {
      updateContent(obj)
        .then(() => {
          Swal.fire({
            title: 'Artigo alterado com sucesso',
            icon: 'success',
          });
          navigate(-1);
        })
        .catch(error => {
          if (error.response.data.errors) {
            Swal.fire({
              title: error.response.data.message,
              icon: 'error',
            });
            error.response.data.errors.map(el =>
              toast({
                message: el.message,
                type: 'warning',
              }),
            );
          } else {
            Swal.fire({
              title: 'Algo deu errado',
              icon: 'error',
            });
          }
        });
    }
  }

  return (
    <>
      {!isLoading && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '900px',
            width: '100%',
            height: 'min-content',
          }}
        >
          <styles.CardInput>
            <FormProvider {...methods}>
              <Content
                clearErrors={clearErrors}
                setError={setError}
                control={control}
                setValue={setValue}
                content={kitsTematic}
                view={isShowing}
                getValues={getValues}
              />
            </FormProvider>
          </styles.CardInput>
          <styles.CardInput>
            <FilesComplementary
              control={control}
              setValue={setValue}
              content={kitsTematic}
              view={isShowing}
              permission="public"
            />
          </styles.CardInput>
          <styles.CardInput>
            <Authors
              clearErrors={clearErrors}
              setError={setError}
              control={control}
              setValue={setValue}
              content={kitsTematic}
              view={isShowing}
            />
          </styles.CardInput>
          <styles.CardInput>
            <Categorization
              control={control}
              setValue={setValue}
              content={kitsTematic}
              view={isShowing}
            />
          </styles.CardInput>
          <styles.CardInput>
            <MainFile
              getValues={getValues}
              titleCompany={'Arquivo'}
              setValue={setValue}
              control={control}
              content={kitsTematic}
              view={isShowing}
              permission="public"
            />
          </styles.CardInput>
          <styles.CardInput>
            <MetaTag
              control={control}
              setValue={setValue}
              content={kitsTematic}
              view={isShowing}
            />
          </styles.CardInput>
          <ButtonGroup2
            view={isShowing}
            handleSubmit={handleSubmit(onSubmit, onError)}
            isExclusive
          />
        </div>
      )}
    </>
  );
};

export default CreateAndEditEbooks;
